// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__23ssC","title":"ClientCherryInfo_title__1Gegi","itemText":"ClientCherryInfo_itemText__1-KUO"};